var _defs, _polygon, _g, _polygon2, _g2, _g3, _g4, _polygon3, _g5, _polygon4, _polygon5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6f6f6e;\n      }\n\n      .cls-2 {\n        fill: #585857;\n      }\n\n      .cls-3 {\n        fill: #c5c5c5;\n      }\n\n      .cls-4 {\n        fill: #8b7f6e;\n      }\n\n      .cls-5 {\n        fill: #a9a9aa;\n      }\n\n      .cls-6 {\n        fill: #5d6864;\n      }\n\n      .cls-7 {\n        fill: #ececec;\n      }\n\n      .cls-8 {\n        fill: #65635f;\n      }\n\n      .cls-9 {\n        fill: #b1b1b0;\n      }\n\n      .cls-10 {\n        fill: #76614a;\n      }\n\n      .cls-11 {\n        fill: #3f3e3e;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "485.27 871.89 60.13 739.03 600.97 643.69 1019.87 701.39 485.27 871.89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "964.25 700.19 969.61 698.68 969.61 395.91 964.25 395.91 964.25 700.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "958.9 697.95 964.25 700.19 964.25 395.91 958.9 397.41 958.9 697.95"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "514.06 837.92 962.67 700.19 962.67 395.91 514.06 458.9 514.06 837.92"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "508.7 839.42 514.06 837.92 514.06 446.43 508.7 446.43 508.7 839.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "503.34 837.19 508.7 839.42 508.7 446.43 503.34 447.94 503.34 837.19"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "129.24 735.73 134.6 735.06 134.6 401.18 129.24 401.18 129.24 735.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "123.89 733.49 129.24 735.73 129.24 401.18 123.89 402.69 123.89 733.49"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "269.64 325.17 102.89 402.99 103.44 404.18 269.64 326.36 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "269.64 325.17 505.13 446.43 505.13 447.63 269.64 326.36 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "986.94 392.15 505.13 446.43 505.13 447.63 986.94 393.34 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "986.94 392.15 505.13 446.43 269.64 325.17 774.8 309.54 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "269.64 338.98 109.09 415 109.09 404.24 269.64 328.21 269.64 338.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "269.64 338.98 505.13 460.01 505.13 449.24 269.64 328.21 269.64 338.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "103.44 404.18 109.09 404.24 269.64 328.21 269.64 326.36 103.44 404.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "109.09 415 269.64 338.98 274.76 341.61 117.35 415 109.09 415"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "269.64 328.21 269.64 326.36 505.13 447.63 505.13 449.24 269.64 328.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "980.6 401.03 505.13 460.01 505.13 449.24 980.6 395.91 980.6 401.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "980.6 395.91 980.6 394.06 505.13 447.63 505.13 449.24 980.6 395.91"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "584.7 315.42 805.49 412.59 817 411.3 596.11 315.07 584.7 315.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "428.68 320.25 657.15 429.31 669.17 427.95 440.48 319.88 428.68 320.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "331.57 323.26 563.79 439.83 576.12 438.44 343.59 322.88 331.57 323.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "350.97 322.65 582.5 437.72 594.77 436.34 362.95 322.28 350.97 322.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "643.43 313.6 860.77 406.36 872.08 405.09 654.68 313.26 643.43 313.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "545.62 316.63 768.53 416.76 780.17 415.45 557.13 316.27 545.62 316.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "604.26 314.82 823.94 410.51 835.38 409.22 615.62 314.46 604.26 314.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "623.84 314.21 842.37 408.44 853.74 407.16 635.15 313.86 623.84 314.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "312.18 323.86 545.07 441.94 557.45 440.54 324.25 323.48 312.18 323.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "467.61 319.04 694.36 425.11 706.26 423.77 479.32 318.68 467.61 319.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "292.8 324.45 526.32 444.05 538.76 442.65 304.91 324.08 292.8 324.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "409.24 320.85 638.52 431.41 650.6 430.04 421.08 320.48 409.24 320.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "448.14 319.65 675.76 427.21 687.72 425.86 459.89 319.28 448.14 319.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "487.1 318.44 712.93 423.02 724.77 421.69 498.75 318.08 487.1 318.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "526.1 317.23 750.02 418.84 761.72 417.52 537.66 316.88 526.1 317.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "370.38 322.05 601.19 435.61 613.4 434.24 382.32 321.68 370.38 322.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "506.59 317.84 731.48 420.93 743.26 419.6 518.2 317.48 506.59 317.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "389.8 321.45 619.86 433.51 632.01 432.14 401.69 321.08 389.8 321.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "565.15 316.03 787.02 414.67 798.6 413.37 576.61 315.67 565.15 316.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "721.93 311.17 934.17 398.09 945.2 396.85 732.97 310.83 721.93 311.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "269.64 325.17 505.13 446.43 520.05 444.75 285.59 324.68 269.64 325.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "702.28 311.78 915.85 400.16 926.95 398.91 713.38 311.44 702.28 311.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "682.65 312.39 897.52 402.22 908.69 400.97 693.8 312.04 682.65 312.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "986.94 392.15 774.8 309.54 761.27 309.96 970.73 393.98 986.94 392.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "663.03 313 879.16 404.29 890.4 403.03 674.23 312.65 663.03 313"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "752.58 310.23 741.59 310.57 952.46 396.03 963.42 394.8 752.58 310.23"
  })))), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "508.7 839.42 129.24 735.73 129.24 409.46 274.76 341.61 508.7 459.57 508.7 839.42"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "418.97 695.29 477.32 702.62 477.32 831.23 478.57 831.46 478.57 701.57 417.71 693.93 417.71 814.82 418.97 815.18 418.97 695.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "418.97 695.29 418.97 815.18 477.32 831.23 477.32 702.62 418.97 695.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "473.13 830.07 423.15 816.33 423.15 698.82 473.13 705.14 473.13 830.07"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 466.26,
    cy: 767.12,
    r: 2.31
  }))), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "383.28 467.77 159.08 446.43 159.08 743.88 383.28 805.15 383.28 467.77"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "163.3 745.21 163.3 458.49 375.99 478.73 375.99 803.33 163.3 745.21"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "368.39 490.41 310.15 484.21 310.15 520.37 368.39 527.44 368.39 490.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "170.04 708.17 170.04 742.23 213.94 753.31 213.94 718.6 170.04 708.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "368.39 543.38 310.15 535.66 310.15 571.81 368.39 580.41 368.39 543.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "368.39 596.35 310.15 587.1 310.15 623.26 368.39 633.38 368.39 596.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "170.04 469.31 170.04 503.37 213.94 508.7 213.94 473.98 170.04 469.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "368.39 649.32 310.15 638.55 310.15 674.7 368.39 686.35 368.39 649.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "170.04 660.4 170.04 694.46 213.94 704.39 213.94 669.67 170.04 660.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "170.04 517.08 170.04 551.14 213.94 557.62 213.94 522.9 170.04 517.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "170.04 564.86 170.04 598.91 213.94 606.54 213.94 571.83 170.04 564.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "170.04 612.63 170.04 646.69 213.94 655.46 213.94 620.75 170.04 612.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.96 584.69 229.13 574.24 229.13 609.18 294.96 620.62 294.96 584.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.96 686.78 229.13 672.88 229.13 707.82 294.96 722.71 294.96 686.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.96 635.74 229.13 623.56 229.13 658.5 294.96 671.67 294.96 635.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.96 737.83 229.13 722.2 229.13 757.14 294.96 773.76 294.96 737.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.96 482.6 229.13 475.6 229.13 510.54 294.96 518.53 294.96 482.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "368.39 755.26 310.15 741.43 310.15 777.59 368.39 792.29 368.39 755.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "368.39 702.29 310.15 689.99 310.15 726.15 368.39 739.32 368.39 702.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "294.96 533.64 229.13 524.92 229.13 559.86 294.96 569.57 294.96 533.64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRv);
export default __webpack_public_path__ + "static/media/RV.958e35f8acf173a6060e7d0e52899ce5.svg";
export { ForwardRef as ReactComponent };